<template>
  <div class="loginCard">
    <el-form class="loginForm" label-position="top" label-width="80px">
      <h2>Tiandy 微信服务</h2>
      <el-form-item label="用户名" class="userNameInput" >
        <el-input v-model="logInFormParams.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label=" 密码" class="passWordInput">
        <el-input  v-model="logInFormParams.password" placeholder="请输入密码" show-password></el-input>
      </el-form-item>
        <el-button type="primary" @click="login" class="loginButton">登录</el-button>
    </el-form>
  </div>

</template>

<script>

export default {
  name: "Login",
  data() {
    return{
      logInFormParams : {
        userName:"",
        password:""
      }
    }
  },
  methods: {
    login(){
      this.$api.post(true, '/wx/auth/login',this.logInFormParams, res => {
        console.log(res)
        if (res.data.statusCode ===  "API-COMMON-INF-OK"){
          sessionStorage.setItem("sid",res.data.content.userId);
          sessionStorage.setItem("userName",this.logInFormParams.userName);
          this.$message({
            message: '登录成功',
            type: 'success',
          })
          this.$router.push("/serviceIndex")
        } else {
          this.$message({
            message: '用户名或密码错误',
            type: 'error',
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .loginCard {
    height: 100%;
    background: #324152;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loginForm{
    width: 400px;
    background: #fff;
    border-radius: 5px;
    padding: 30px;
  }
  .loginButton{
    width: 100%;
  }
</style>